// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import InitialLoadGate from './components/InitialLoadGate/InitialLoadGate';


import { ApolloProvider } from '@apollo/client';
import client from './apollo-client';


import { AuthProvider } from './AuthContext.jsx';

// Tailwind solo con components y utilities (sin base que resetea fuentes)
import './tailwind.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <InitialLoadGate>

  <ApolloProvider client={client}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ApolloProvider>
  </InitialLoadGate>
);
